<template>
  <AdminLayout />
</template>

<script setup lang="ts">
import AdminLayout from './layouts/AdminLayout.vue';
</script>
